/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2022-09-15 11:26:10
 * @LastEditors: hongye
 * @LastEditTime: 2025-10-31 10:05:04
 */
import type { App } from 'vue'
import 'ant-design-vue/dist/antd.less'
import '@xinghai/site-common/dist/es/index.css'
import doubleClickCopy from '@/utils/directives/doubleClickCopy/doubleClickCopy'

const plugins: any[] = [doubleClickCopy]

export default function registerPlugin(app: App) {
  plugins.forEach((p) => app.use(p))
}
